import React from "react";



export default function SEARCHES() {

    //  variable declarations ------------------------------------------------------------------------------------------

    //  event listeners ------------------------------------------------------------------------------------------------


    //  async functions ------------------------------------------------------------------------------------------------


    //  API calls ------------------------------------------------------------------------------------------------------


    //  event functions ------------------------------------------------------------------------------------------------



    // RENDER CONTAINER ================================================================================================

    return (
        <div className='page'>
            <div className='page__header'>
                <div className='text--xl medium'>Searches</div>
            </div>
        </div>
    );

}